import fails$1 from './fails.js';
import createPropertyDescriptor$1 from './create-property-descriptor.js';

var fails = fails$1;
var createPropertyDescriptor = createPropertyDescriptor$1;
var errorStackInstallable = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true; // eslint-disable-next-line es/no-object-defineproperty -- safe

  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

export { errorStackInstallable as default };
